import { __, _x, sprintf } from "@wordpress/i18n";

export default function StoreItem({
  id,
  name,
  distance,
  phones,
  currentHours,
  isOpen,
  street,
  postalcode,
  city,
  url,
}) {
  const isClose = !currentHours || !currentHours.length;
  const hours = isClose
    ? __("Fermé aujourd'hui", "manitoba-stores")
    : sprintf(
        __("Ouvert%s", "manitoba-stores"),
        currentHours
          .map((period) => {
            const [startsAt, endsAt] = period.split(/[^\d:h]/, 2);
            return sprintf(
              __(" de %s à %s", "manitoba-stores"),
              startsAt,
              endsAt
            );
          })
          .join(_x(",", "séparateur d'horaires", "manitoba-stores"))
      );

  const address = sprintf(
    _x("%s, %s %s", "Adresse, avec rue, code postal, ville", "manitoba-stores"),
    street,
    postalcode,
    city
  );

  return (
    <div
      className={
        "store" +
        (isClose ? " store--close" : "") +
        (isOpen ? " store--open" : "")
      }
    >
      <h4 className="store-name">
        {name}
        {!!distance && (
          <span className="store-distance">
            {sprintf(__(" - %d km", "manitoba-stores"), Math.round(distance))}
          </span>
        )}
      </h4>
      <p
        className={
          "store-hours" +
          (isClose ? " store-hours--close" : "") +
          (isOpen ? " store-hours--open" : "")
        }
      >
        {hours}
      </p>
      <p className="store-address">{address}</p>
      <p className="store-contact">
        {!!phones && phones.length && (
          <a
            href={`tel:${phones[0].replace(/[^\d+]/gim, "")}`}
            className="store-contact-phone"
            data-agency-id={id}
          >
            {phones[0]}
          </a>
        )}
      </p>
      <div className="store-actions">
        {!!url && (
          <a
            className="store-actions-detail"
            href={url}
            title={sprintf(
              __("Voir le détail de l'agence %s", "manitoba-stores"),
              name
            )}
          >
            {__("Plus d'info", "manitoba-stores")}
          </a>
        )}
      </div>
    </div>
  );
}
